import { KalturaBillingTransaction } from '@kaltura-ott/ott-client-types/api/types';
import {
  UIDAPresentationTypeEnum,
  getSelfServiceLinks,
  KuxSelfServiceLink,
  KuxFilteredCategoriesDTO,
  transactionsHistoryRecursively,
} from '@kaltura-ott/tvpil';
import { action } from 'mobx';
import { lastValueFrom } from 'rxjs';

import { errorHandling } from '../../../../utils/error-handling';
import { SubpageStore } from '../subpage-store';

/**
 * @category Store
 */
export class SelfServiceStore extends SubpageStore {
  static moduleName = 'SelfServiceStore';

  isReady = false;
  subtype: UIDAPresentationTypeEnum.link_list = UIDAPresentationTypeEnum.link_list;
  purchaseHistory: Array<KalturaBillingTransaction>;
  links: Array<KuxSelfServiceLink>;

  constructor(props: KuxFilteredCategoriesDTO, categoryTree: KuxFilteredCategoriesDTO, children?: []) {
    super(props, categoryTree, children);

    this.purchaseHistory = [];
    this.links = [];
  }

  @action
  @errorHandling()
  async init() {
    super.init();
    this.purchaseHistory = (await lastValueFrom(transactionsHistoryRecursively())).objects;
    this.links = await lastValueFrom(getSelfServiceLinks(this.channels[0]));

    this.isReady = true;
  }
}
